import React, { Component } from 'react';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { NavLink } from "react-router-dom";
import Select2 from 'react-select2-wrapper';
import $ from 'jquery';
import UnAuthorised from "./UnAuthorised";
import { Alert } from 'rsuite';
import 'react-select2-wrapper/css/select2.css';
import {
  Dashboard_Api_clients,
  LOGIN_TYPE_ADMIN,
  LOGIN_TYPE_USER,
  SERVICE14_TEXT
} from './helper/Constants';

import Apihelpers from './helper/ApiHelper';
import { reactLocalStorage } from "reactjs-localstorage";
import Header from "./include/Header";
import { callbackify } from 'util';


class ApiHistory extends Component {
  state = {
    rcNum: "",
    startDate:"",
    endDate:"",
    clientist: [{ text:'Client', id:-1, value:'all client'}],
    selectUser: 'all client',
    apiType:'9',
    backDate:'',
    historyList:[],
    urlForBackButton:'',
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {

    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
      this.setState({urlForBackButton:`${"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id")}`});
    }

    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.setState({urlForBackButton:`${"/admin/dashboard"}`});
    }

    let d = new Date();
    let today = new Date(d.getFullYear(), d.getMonth(), 2).toISOString().slice(0, 10);
    //console.log('today',today);
    d.setDate(d.getDate() - 90);
    this.setState({
      startDate: today,
      endDate:new Date().toISOString().slice(0, 10),
      backDate:d.toISOString().slice(0, 10)
    });

    $(document).ready(function(){
      $(".apiHitList").on('click','.showMore',function(){
        var moreVal = $(this).parents('tr').next('tr').find('.moreVal');
        if (moreVal.is(':visible')) {
          moreVal.css('display','none');
        } else {
          $(".apiHitList").find('.moreVal').css('display','none');
          moreVal.css('display','table-cell');
        }
      });
    })

    this.loadClientList();
  }

  loadClientList() {
    Apihelpers.getdataresponse(Dashboard_Api_clients).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data', res.data.data);
        let clientist = [{ text:'Client', id:-1, value:'all client'}];
        res.data.data.map((item, i) =>
          clientist.push({ text: item.name, id: i, value: item._id })
        )
        //console.log('clientist',clientist);
        this.setState({
          clientist: clientist,
        });
      } else {
        console.log('res.data', res.data);
      }
    });
  }

  filterData = () => {
    if (this.state.rcNum.length < 8 || this.state.rcNum.length > 11) {
      Alert.error("Please type Valid RC Number");
      return;
    }
    if (this.state.startDate === "" || this.state.endDate === "") {
      Alert.error("Please select start date & end date");
      return;
    }
    let startD = this.state.startDate;
    let endD = this.state.endDate;
    let dayDiff = Math.abs(new Date(endD) - new Date(startD));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (dayDiff > 15) {
      Alert.error("Please select date range maximum 15 days");
      return;
    }
    let apiType = this.state.apiType;
    if (this.state.apiType !== 'all') {
      apiType = parseInt(this.state.apiType);
    }
    let data = {
      rcNum: this.state.rcNum,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      selectUser: this.state.selectUser,
      apiType: apiType
    }
    console.log('data',data);
    $(".loader").show();
    Apihelpers.postdataresponse("Dashboard/apiHistoryList/", data).then(res => {
      if (res.data.status === true) {
        //console.log('res.data', res.data.data);
        this.setState({
          historyList:res.data.data
        })
      } else {
        console.log('res.data', res);
        this.setState({
          historyList:[]
        })
      }
      $(".loader").hide();
    });
  }
  //Alert.error("error msg");
  //Alert.success('sucess msg');
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_api-history_service") === SERVICE14_TEXT) {
      const is_data = this.state.is_data_found;
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="whiteBox apiHistoryPage">
              <div className="titleRow">
                <div className="row align-items-center">
                  <div className="col">
                    <h3 className="title">RC Number API Hit History </h3>
                    <div className="noteTextrcexcelList"> Note: If the Hit Time is same, then the top one is delivered to the Client.</div>
                  </div>
                  <div className="col-auto">
                      <NavLink to={this.state.urlForBackButton} className="backLink"><i className="fa fa-arrow-left"></i> Back</NavLink>
                    </div>
                </div>
              </div>
                <div className="form blockFilter">
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">RC Number </label>
                        <input className="form-control" value={this.state.rcNum} placeholder="Enter Rc Prime" onChange={(e) => this.setState({rcNum:e.target.value.toLocaleUpperCase()})} type="text"/>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="control-title">Start Date </label>
                        <input className="form-control" placeholder="Start Date" type="date"  min={this.state.backDate} onChange={(e) => this.setState({startDate:e.target.value})} value={this.state.startDate} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="control-title">End Date </label>
                        <input className="form-control" placeholder="End Date" type="date" min={this.state.backDate} onChange={(e) => this.setState({endDate:e.target.value})} value={this.state.endDate} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="control-title">Client</label>
                        <Select2
                            data={this.state.clientist}
                            options={{
                              placeholder: 'Select Client',
                            }}
                            className="form-control"
                            value={this.state.selectUser}
                            onChange={(e) => this.setState({ selectUser: e.target.value })}
                          />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="control-title">API Type</label>
                        <select className="form-control" value={this.state.apiType} onChange={(e)=>this.setState({apiType:e.target.value})}>
                          <option value="9">RCPrime</option>
                          <option value="10">RCExcel</option>
                          <option value="3">ServiceHistory</option>
                          <option value="2">Challan</option>
                          <option value="36">ChallanExcel</option>
                          <option value="32">comboPrime</option>
                          <option value="33">comboChallan</option>
                          <option value="14">UsedCarPricing</option>
                          <option value="38">comboMobilePrimeExcel</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-auto">
                      <button className="blueBtn" onClick={this.filterData} type="button">Submit</button>
                    </div>
                  </div>
                </div>
                <div className="apiHitList table-responsive" style={{height:`calc(100vh - 370px)`}}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Client</th>
                        <th>Hit Time</th>
                        <th>API Type</th>
                        <th>Source</th>
                        <th>Status</th>
                        <th>Response</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.historyList.length ?
                        this.state.historyList.map((item, i) => (
                          <React.Fragment key={i}>
                          <tr>
                            <td>
                              {(item.output[0]) ? item.output[0].name : ''}
                            </td>
                            <td>{item.hit_time.slice(0, 10)} - {item.hit_time.slice(11, 19)}</td>
                            <td>{item.servicename[0].serviceName}</td>
                            <td>{item.rc_prime_source}</td>
                            <td>{item.rc_prime_source_response_details_type}</td>
                            <td><span className="showMore"></span></td>
                          </tr>
                          <tr>
                          <td className="moreVal" colSpan="7">
                            <pre className="preTag">{JSON.stringify(JSON.parse(item.response_result), null, 2)}</pre>
                          </td>
                        </tr>
                        </React.Fragment>
                        )) : (
                          <tr><td colSpan="6" align="center"><br /> <br />No Data Found<br /><br /><br /></td></tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
                <div className="text-center">
                *Please select date range maximum 15 days.<br />
                *Report data have a maximum limit of 20 records, please narrow down your search with appropriate date range.<br />
                *Please do not select 90 days back date range.
                </div>
            </div>
          </div>
          <div className="loader isload" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </div>
      );
    }
    else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}
export default ApiHistory;
